/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'draft': {
    width: 200,
    height: 153.846,
    viewBox: '0 0 200 153.846',
    data: '<path pid="0" fill-rule="evenodd" opacity=".9" d="M0 15.38v123.08c0 8.49 6.88 15.39 15.38 15.39h169.24c8.5 0 15.38-6.9 15.38-15.39V15.38C200 6.89 193.12 0 184.62 0H15.38C6.88 0 0 6.89 0 15.38zm100 52.3l78.44-52.3H21.56L100 67.68zm84.62 70.78V29.75L100 86.17 15.38 29.75v108.71h169.24z" _fill="#000"/>'
  }
})
